import MenuComponent from '@/components/MenuComponent'
import BlocAuthenticated from '@/components/BlocAuthenticated'
import hasPermission from '@/utils/utils.js'

import $ from 'jquery'

export default {
  components: {
    MenuComponent,
    BlocAuthenticated
  },

  data: function () {
    return {
      permissions: this.$store.state.user.user ? this.$store.state.user.user.permissions : [],
      hasPermission
    }
  },
  beforeCreate () {
    this.$store.state.filArianePage = 'Documentation'
  },
  mounted () {
    if (this.$store.state.user.user && this.$store.state.user.user.infoMessage) {
      $('#modalGestionnaire').modal('show')
    }
  }
}
